export enum FluxoNegocioEnum {
  Extrato = 1,
  Pix = 2,
  Boleto = 3
}
